<mat-slide-toggle
  [disabled]="isDisabled"
  (change)="switchSmartOffsetsMode($event)"
  [checked]="isChecked"
  placement="left"
  [ngbTooltip]="stateInfo | translate">
  {{'SMART_OFFSET_MODE' | translate}}
</mat-slide-toggle>
